
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"70","height":"70","fill":"none","viewBox":"0 0 70 70"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"35","cy":"35","r":"35","fill":"#4267B2"}}),_c('g',{attrs:{"clip-path":"url(#facebook_svg__clip0)"}},[_c('path',{attrs:{"fill":"#fff","d":"M42.675 28.962a.64.64 0 00-.463-.212H37.5v-1.762c0-.35.075-.75.638-.75h3.75a.566.566 0 00.24-.044.561.561 0 00.197-.144.624.624 0 00.175-.425v-5a.625.625 0 00-.625-.625h-5.413c-6 0-6.462 5.125-6.462 6.688v2.062h-3.125a.625.625 0 00-.625.625v5a.625.625 0 00.625.625H30v14.375a.625.625 0 00.625.625h6.25a.625.625 0 00.625-.625V35h4.188a.625.625 0 00.625-.563l.524-5a.61.61 0 00-.162-.474z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"facebook_svg__clip0"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h30v30H0z","transform":"translate(20 20)"}})])])])
          )
        }
      }
    